import { useNavigate } from "react-router-dom";
import { Screen } from "../components/Screen";
import { track } from "../analytics/track";

/** п.2 ТЗ: головний екран — просто й зрозуміло, 6 плиток. */
const TILES = [
  { path: "/cars/new", icon: "🚗", title: "Нові Toyota", subtitle: "Переглянути модельний ряд" },
  { path: "/cars/inventory", icon: "📦", title: "Авто в наявності", subtitle: "Переглянути конкретні автомобілі зі складу" },
  { path: "/cars/used", icon: "🔁", title: "Авто з пробігом", subtitle: "Переглянути актуальну пропозицію" },
  { path: "/credit", icon: "💳", title: "Розрахувати кредит", subtitle: "Порівняти доступні програми фінансування" },
  { path: "/trade-in", icon: "🔄", title: "Trade-in / Оцінка авто", subtitle: "Використати власний автомобіль як аванс" },
  { path: "/consultants", icon: "👤", title: "Консультанти", subtitle: "Зв'язатися з працівником дилерського центру" },
];

export function Home() {
  const navigate = useNavigate();
  return (
    <Screen title="Що Вас цікавить?">
      <div className="card-list">
        {TILES.map((tile) => (
          <button
            key={tile.path}
            className="menu-tile"
            onClick={() => {
              track("open_miniapp", { tile: tile.path });
              navigate(tile.path);
            }}
          >
            <span className="menu-tile-icon">{tile.icon}</span>
            <span className="menu-tile-text">
              <span className="menu-tile-title">{tile.title}</span>
              <span className="menu-tile-subtitle">{tile.subtitle}</span>
            </span>
          </button>
        ))}
      </div>
    </Screen>
  );
}
